'use client';

import { ArrowLeft, Handshake, TrendingUp, Users, Award, Package, Store } from 'lucide-react';
import Link from 'next/link';
import { Button } from '@myapp/ui/components/button';

export default function PartnershipPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-6">
          <Button variant="ghost" size="sm" asChild>
            <Link href="/" className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              홈으로 돌아가기
            </Link>
          </Button>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">제휴문의</h1>
          <p className="text-lg text-gray-600 mb-8">강원푸드핏과 함께 성장할 파트너를 찾습니다</p>
          
          <div className="prose prose-gray max-w-none">
            <section className="mb-10">
              <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-6 mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-3 flex items-center gap-2">
                  <Handshake className="w-6 h-6 text-green-600" />
                  파트너십 비전
                </h2>
                <p className="text-gray-600">
                  강원푸드핏은 강원도의 우수한 농산물을 전국에 알리고, 농가와 소비자를 직접 연결하는 플랫폼입니다.
                  함께 지속가능한 농업 생태계를 만들어갈 파트너를 모집합니다.
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-semibold text-gray-800 mb-6">제휴 분야</h2>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div className="border border-gray-200 rounded-lg p-5 hover:shadow-lg transition-shadow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                      <Package className="w-5 h-5 text-green-600" />
                    </div>
                    <h3 className="font-semibold text-gray-800">농가 파트너</h3>
                  </div>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li>• 강원도 지역 농산물 생산자</li>
                    <li>• 친환경/유기농 인증 농가</li>
                    <li>• 특산물 재배 전문 농가</li>
                    <li>• 농업 협동조합</li>
                  </ul>
                  <div className="mt-4 p-3 bg-green-50 rounded-lg">
                    <p className="text-xs text-green-700">
                      <strong>혜택:</strong> 판로 확대, 마케팅 지원, 안정적 수익 보장
                    </p>
                  </div>
                </div>

                <div className="border border-gray-200 rounded-lg p-5 hover:shadow-lg transition-shadow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Store className="w-5 h-5 text-blue-600" />
                    </div>
                    <h3 className="font-semibold text-gray-800">유통 파트너</h3>
                  </div>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li>• 물류/배송 전문 기업</li>
                    <li>• 콜드체인 시스템 보유 업체</li>
                    <li>• 지역 유통 거점</li>
                    <li>• 포장재 공급 업체</li>
                  </ul>
                  <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                    <p className="text-xs text-blue-700">
                      <strong>혜택:</strong> 장기 계약, 물량 보장, 성장 기회
                    </p>
                  </div>
                </div>

                <div className="border border-gray-200 rounded-lg p-5 hover:shadow-lg transition-shadow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                      <TrendingUp className="w-5 h-5 text-purple-600" />
                    </div>
                    <h3 className="font-semibold text-gray-800">마케팅 파트너</h3>
                  </div>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li>• 디지털 마케팅 에이전시</li>
                    <li>• 콘텐츠 크리에이터</li>
                    <li>• 푸드 인플루언서</li>
                    <li>• 미디어/언론사</li>
                  </ul>
                  <div className="mt-4 p-3 bg-purple-50 rounded-lg">
                    <p className="text-xs text-purple-700">
                      <strong>혜택:</strong> 콜라보레이션, 수수료, 브랜드 제휴
                    </p>
                  </div>
                </div>

                <div className="border border-gray-200 rounded-lg p-5 hover:shadow-lg transition-shadow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <Users className="w-5 h-5 text-orange-600" />
                    </div>
                    <h3 className="font-semibold text-gray-800">기업 파트너</h3>
                  </div>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li>• B2B 대량 구매 기업</li>
                    <li>• 급식/케이터링 업체</li>
                    <li>• 호텔/레스토랑</li>
                    <li>• 복지몰 운영 기업</li>
                  </ul>
                  <div className="mt-4 p-3 bg-orange-50 rounded-lg">
                    <p className="text-xs text-orange-700">
                      <strong>혜택:</strong> 기업 할인, 맞춤 서비스, 정기 배송
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-semibold text-gray-800 mb-6">제휴 혜택</h2>
              <div className="bg-gradient-to-r from-green-500 to-blue-600 text-white rounded-xl p-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="font-semibold mb-3 flex items-center gap-2">
                      <Award className="w-5 h-5" />
                      농가 파트너 혜택
                    </h3>
                    <ul className="text-sm space-y-2 opacity-95">
                      <li>✓ 수수료 우대 (업계 최저 10%)</li>
                      <li>✓ 무료 마케팅 지원</li>
                      <li>✓ 전문 사진 촬영 서비스</li>
                      <li>✓ 월 최소 판매량 보장</li>
                      <li>✓ 농가 스토리 콘텐츠 제작</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-3 flex items-center gap-2">
                      <Award className="w-5 h-5" />
                      비즈니스 파트너 혜택
                    </h3>
                    <ul className="text-sm space-y-2 opacity-95">
                      <li>✓ 독점 계약 기회</li>
                      <li>✓ 공동 마케팅 캠페인</li>
                      <li>✓ 데이터 인사이트 제공</li>
                      <li>✓ 우선 협상권</li>
                      <li>✓ 성과 인센티브</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-semibold text-gray-800 mb-6">제휴 절차</h2>
              <div className="relative">
                <div className="absolute left-8 top-8 bottom-0 w-0.5 bg-gray-300"></div>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg z-10">
                      1
                    </div>
                    <div className="flex-1 bg-gray-50 rounded-lg p-4">
                      <h3 className="font-semibold text-gray-800 mb-1">제휴 신청</h3>
                      <p className="text-sm text-gray-600">온라인 신청서 작성 또는 전화 문의</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg z-10">
                      2
                    </div>
                    <div className="flex-1 bg-gray-50 rounded-lg p-4">
                      <h3 className="font-semibold text-gray-800 mb-1">상담 및 검토</h3>
                      <p className="text-sm text-gray-600">담당자 배정 및 맞춤 제안서 제공 (영업일 기준 3일 이내)</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg z-10">
                      3
                    </div>
                    <div className="flex-1 bg-gray-50 rounded-lg p-4">
                      <h3 className="font-semibold text-gray-800 mb-1">계약 체결</h3>
                      <p className="text-sm text-gray-600">세부 조건 협의 및 정식 계약</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg z-10">
                      4
                    </div>
                    <div className="flex-1 bg-gray-50 rounded-lg p-4">
                      <h3 className="font-semibold text-gray-800 mb-1">온보딩</h3>
                      <p className="text-sm text-gray-600">시스템 연동, 교육, 초기 세팅 지원</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg z-10">
                      5
                    </div>
                    <div className="flex-1 bg-gray-50 rounded-lg p-4">
                      <h3 className="font-semibold text-gray-800 mb-1">파트너십 시작</h3>
                      <p className="text-sm text-gray-600">정기 미팅 및 지속적인 성장 지원</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-semibold text-gray-800 mb-6">자주 묻는 질문</h2>
              <div className="space-y-4">
                <div className="border-l-4 border-green-500 pl-4">
                  <p className="font-medium text-gray-700 mb-1">Q: 제휴 신청 자격이 있나요?</p>
                  <p className="text-gray-600">A: 사업자등록증을 보유한 모든 사업체가 신청 가능합니다. 개인 농가의 경우 농업경영체 등록증으로 대체 가능합니다.</p>
                </div>
                <div className="border-l-4 border-green-500 pl-4">
                  <p className="font-medium text-gray-700 mb-1">Q: 초기 비용이 발생하나요?</p>
                  <p className="text-gray-600">A: 별도의 가입비나 초기 비용은 없습니다. 판매 수수료만 발생합니다.</p>
                </div>
                <div className="border-l-4 border-green-500 pl-4">
                  <p className="font-medium text-gray-700 mb-1">Q: 계약 기간은 어떻게 되나요?</p>
                  <p className="text-gray-600">A: 기본 1년 단위 계약이며, 상호 협의 하에 조정 가능합니다.</p>
                </div>
                <div className="border-l-4 border-green-500 pl-4">
                  <p className="font-medium text-gray-700 mb-1">Q: 타 플랫폼과 중복 입점이 가능한가요?</p>
                  <p className="text-gray-600">A: 네, 가능합니다. 독점 계약을 원하시는 경우 별도 혜택을 제공합니다.</p>
                </div>
              </div>
            </section>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">지금 바로 문의하세요!</h3>
                <div className="grid md:grid-cols-3 gap-6 mb-6">
                  <div className="text-center">
                    <p className="text-sm text-gray-600 mb-1">전화 문의</p>
                    <p className="font-semibold text-gray-800">033-248-2000</p>
                    <p className="text-xs text-gray-500">평일 09:00~18:00</p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm text-gray-600 mb-1">이메일</p>
                    <p className="font-semibold text-gray-800">partner@gangwonfoodfit.kr</p>
                    <p className="text-xs text-gray-500">24시간 접수</p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm text-gray-600 mb-1">카카오톡</p>
                    <p className="font-semibold text-gray-800">@강원푸드핏비즈</p>
                    <p className="text-xs text-gray-500">실시간 상담</p>
                  </div>
                </div>
                <div className="text-center">
                  <Button size="lg" className="bg-gradient-to-r from-green-500 to-blue-600 hover:from-green-600 hover:to-blue-700">
                    온라인 제휴 신청하기
                  </Button>
                </div>
              </div>
              
              <p className="text-sm text-gray-500 text-center mt-6">
                최종 수정일: 2025년 1월 1일
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}